import {
    convertCurrencyFormat,
    convertUniversalDateTimeToPersianDateTime,
    convertUniversalDateToPersianDate
} from "@moeindal/base-raiko-panel-components";

export  function createResidenceTableRow(number, id, title, address, menCapacity, womenCapacity, createdAt, createdBy,fullAddress) {
    return {
        number,
        id,
        title,
        address,
        menCapacity,
        womenCapacity,
        createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
        createdBy,
        fullAddress
    }
}

export const residenceTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "title",
        label: "عنوان"
    },
    {
        id: "address",
        label: "نشانی"
    },
    {
        id: "menCapacity",
        label: "ظرفیت آقا"
    },
    {
        id: "womenCapacity",
        label: "ظرفیت خانم"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
]